module.exports = __webpack_public_path__ + "static/media/machobanners_sm3.802788e8.png";